import script from "./Container.vue?vue&type=script&setup=true&lang=js"
export * from "./Container.vue?vue&type=script&setup=true&lang=js"

import "./Container.vue?vue&type=style&index=0&id=7ba7cb6a&lang=scss&scoped=true"
script.__scopeId = "data-v-7ba7cb6a"

export default script